"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconList = exports.iconnameToCSSName = exports.iconnameToReadableName = void 0;
var IconFunctions = __importStar(require("./icons"));
/**
 * Convert a Honeycomb Icon name to a readable name
 * e.g "iconControlShareIOS" -> "control share ios"
 */
exports.iconnameToReadableName = function (iconname) {
    return iconname
        .split('')
        .reduce(function (acc, chr, index) {
        if (index === 0) {
            // Return the first character
            return chr;
        }
        var result = '';
        if ((iconname[index - 1] + chr).match(/[a-z][A-Z0-9]/)) {
            // When a lowercase character is followed by an uppercase character or number, insert a space between them
            // e.g the "eA" and "t3" matches in "messageAlert32" result in "message Alert 32"
            result = acc + " " + chr;
        }
        else if ((iconname[index - 1] + chr).match(/[A-Z][0-9]/)) {
            // When an uppercase character is followed by a number, insert a space between them
            // e.g the "A3" match in "logoCBA32" results in "logo CBA 32"
            result = acc + " " + chr;
        }
        else if (iconname.length >= 2 && (iconname[index - 2] + iconname[index - 1] + chr).match(/[A-Z]{2}[a-z]/)) {
            // When two uppercase characters are followed by a lowercase character, insert a space before the last uppercase
            // e.g the "ASy" match in "logoCBASymbol" results in "logo CBA Symbol"
            result = acc.slice(0, -1) + " " + acc.slice(-1) + chr;
        }
        else {
            result = acc + chr;
        }
        return result;
    }, '')
        .replace(/^(icon\s)/, '')
        .toLowerCase();
};
/**
 * Convert the icon name to the CSS name
 * e.g "controlAccordionClose24" to "iconControlAccordionClose24"
 * @param iconname
 */
exports.iconnameToCSSName = function (iconname) {
    var cleanIconname = iconname.replace(/^icon/, '');
    var classname = 'icon';
    classname += cleanIconname.charAt(0).toUpperCase();
    classname += cleanIconname.slice(1);
    return classname;
};
// tslint:enable typedef-whitespace
exports.IconList = {};
// Create a list of icons using the functions that were generated from the SVG files
Object.keys(IconFunctions)
    .sort()
    .forEach(function (iconName) {
    var css = 'icon' + iconName.charAt(0).toUpperCase() + iconName.slice(1);
    exports.IconList[iconName] = {
        css: css,
        name: exports.iconnameToReadableName(iconName),
        svgfile: iconName + ".svg",
        // @ts-ignore
        svginline: IconFunctions[iconName],
        // @ts-ignore
        svginlineArgs: IconFunctions[iconName + "Args"],
    };
});
